import React, { useEffect, useMemo, useRef, useState } from 'react'
import Swal from 'sweetalert2';
import DataTable from "react-data-table-component";
import Tablefilter from "../common/Tablefilter";
import { RenderEvidences, RenderQuestionLevel, RenderQuestionType } from '../../utils/CommonGroupingItem';
import { Link, useParams } from 'react-router-dom';
import { GetimportMarks, GetMarkasCompelete, GetMarkingAssessmentQuestions, GetMarkingAssessmentQuestionsCancelToken, GetMarkingAssessmentQuestionsFilters } from '../../services/CourseService';
import axios from "axios";
import SkeletonTicketList from '../../loaders/SkeletonTicketList';
import Papa from "papaparse";
import JsPDF from "jspdf";
import * as XLSX from "xlsx";
import { FilePond } from "react-filepond";
import $ from "jquery"
import { GroupHeader, groups, GroupStyle } from './Helper';
import {handleDownloadAssessment } from './DownloadAssessment';
import DownloadModalComponent from '../courses/DetailCoursesBlocks/AssessmentBlocks/DownloadModalComponent';
import { popupSuccessSimple } from '../../utils/Popups';

function AssessmentStudentList({ assessmentDetails, fetchAssessmentDetails }) {
  const { id, subId } = useParams();
  const [search, setSearch] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [questionLoading, setQuestionLoading] = useState(false)
  const [filterData, setFilterData] = useState({ type: [], evidenceRequired: [], level: [] });
  const [type, setType] = useState({ arr: [], checkObj: {} });
  const [evidenceRequired, setEvidenceRequired] = useState({ arr: [], checkObj: {} });
  const [level, setLevel] = useState({ arr: [], checkObj: {} });
  const [expandedGroups, setExpandedGroups] = useState({
    hybrid: true,
    smart: false
  });
  const [notificationval, setNotificationVal] = useState(false)
  const [zipfileupload, setZipFileUpload] = useState("")
  const [finalTotal, setFinalTotal] = useState(0)
  const [FinalLoadedData, setFinalLoadedData] = useState(0)
  const [isHybrid, setIsHybrid] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [markingLoading, setMarkingLoading] = useState(false);
  const inputRef = useRef(null);
  const downloadRef = useRef(null);

  /**
   * Indicates whether the assessment uses the "Not Graded" grading type.
   * Grading type value 4 represents assessments that are not graded.
  */
  const isNotGraded= Number(assessmentDetails?.grading_type) === 4;
  // Create grouped data
  const groupedQuestions = useMemo(() => {
    // Add styling to questions
    const styledQuestions = quizQuestions.map(question => ({
      ...question,
      className: question.getMarkedQuectionCount == question.getTotalStudets ? 'white-bg' : question.getMarkedQuectionCount > 0 ? 'yellow-gradian-bg' : 'red-gradian-bg'
    }));

    // Create grouped array with headers and filtered questions
    return groups.reduce((acc, group) => {
      // Add group header
      const filteredQuestions = styledQuestions.filter(group.filter);

      if (filteredQuestions.length > 0) {
        acc.push({
          id: `${group.id}-header`,
          isGroupHeader: true,
          group: group
        });
      }

      if (expandedGroups[group.id]) {
        const filteredQuestions = styledQuestions.filter(group.filter);
        acc.push(...filteredQuestions);
      }

      return acc;
    }, []);
  }, [quizQuestions, expandedGroups]);

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const renderEvidences = (row) => {
    return (
      <div className='evidence__box'>
        {/* Evidence Photo */}
        {row?.evidence_photo == 1 && <span className='evidence__item' title='Photo'>
          <i className="fal fa-camera evidence" />
          <span className='ml-2' style={{ fontSize: 16 }}>
            Photo
          </span>
        </span>}

        {/* Evidence Video */}
        {row?.evidence_video == 1 && <span className='evidence__item' title='Video'>
          <i className="fal fa-video evidence" />
          <span className='ml-2' style={{ fontSize: 16 }}>
            Video
          </span>
        </span>}

        {/* Evidence Lecturer Observation */}
        {row?.evidence_lecturer_observation == 1 && <div className='my-2'>
          <span className='evidence__item' title='Lecturer Observation'>
            <i className="fal fa-user-check evidence" />
            <span className='ml-2' style={{ fontSize: 16 }}>
              Lecturer Observation
            </span>
          </span>
        </div>
        }
      </div>
    );
  };

  /**
   * Table column configuration for question listing.
  */
  const columns = useMemo(() => [
    {
      name: "Question",
      selector: "Question",
      sortField: "question_name",
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupHeader
              group={row?.group}
              onClick={() => toggleGroup(row?.group?.id)}
            />
          );
        }

        return (
          <Link
            className='as-text-blue curser feature-name'
            title={row?.question_name}
            to={`?questionId=${row?.qid}`}
          >
            <span className='textLimit100'>
              {row?.question_name}
            </span>
          </Link>
        );
      },
    },
    {
      name: "Type",
      selector: "Type",
      sortField: "question_type",
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupStyle
              onClick={() => toggleGroup(row?.group?.id)}
            />
          );
        }

        return row?.question_type
          ? RenderQuestionType(row?.question_type?.trim())?.html
          : '-';
      },
    },
    {
      name: "Evidence Required",
      selector: "evidence_required",
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupStyle
              onClick={() => toggleGroup(row?.group?.id)}
            />
          );
        }

        const hasEvidence =
          Number(row?.evidence_photo) === 1 ||
          Number(row?.evidence_video) === 1 ||
          Number(row?.evidence_lecturer_observation) === 1;

        return hasEvidence
          ? renderEvidences(row)
          : '-';
      },
    },
    {
      name: "Score",
      selector: "score",
      sortField: "score",
      sortable: false,
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupStyle
              onClick={() => toggleGroup(row?.group?.id)}
            />
          );
        }

        if (isNotGraded) {
          return 'Not Graded';
        }

        const scoreText = row?.correct_score || '-';

        return (
          <p title={scoreText}>
            {scoreText}
          </p>
        );
      },
    },
    {
      name: "Level",
      selector: "level",
      sortField: "level",
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupStyle
              onClick={() => toggleGroup(row?.group?.id)}
            />
          );
        }

        return row?.level_name
          ? RenderQuestionLevel(row?.level_name)?.html
          : '-';
      },
    },
    {
      name: "Marked",
      selector: "marked",
      sortField: "marked",
      sortable: false,
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupStyle
              onClick={() => toggleGroup(row?.group?.id)}
            />
          );
        }

        if (isNotGraded) {
          return 'Not Graded';
        }

        const markedStatus = row?.mark_status || '-';

        return (
          <p title={markedStatus}>
            {markedStatus}
          </p>
        );
      },
    },
    {
      name: "Component Code",
      selector: "component_code",
      sortField: "component_code",
      sortable: false,
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupStyle
              onClick={() => toggleGroup(row?.group?.id)}
            />
          );
        }

        const componentCode = row?.component_code || '-';

        return (
          <p title={componentCode}>
            {componentCode}
          </p>
        );
      },
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => {
        if (row?.isGroupHeader) {
          return (
            <GroupStyle
              onClick={() => toggleGroup(row?.group?.id)}
            >
              <i
                className={`fal fa-${expandedGroups[row?.group?.id]
                    ? 'minus'
                    : 'plus'
                  }-circle questions-group-icon`}
                style={{ color: '#477998' }}
              />
            </GroupStyle>
          );
        }

        return (
          <div className='assessment-08 btn-dropdown-grp'>
            <div className='as-buttons'>
              <Link
                to={`?questionId=${row?.qid}`}
                className='btn btn-primary rounded-circle'
                title='Open'
              >
                <i className='fal fa-folder-open' />
              </Link>
            </div>
          </div>
        );
      },
    },
  ]);

  /**
   * Returns export headers for question export functionality.
   *
   * @param {string} fileType - Type of export file (e.g., csv, xlsx, pdf)
   * @param {string} fileName - Name of the exported file
   * @returns {Array<string>} Array of column headers used in export
  */
  const exportData = (fileType, fileName) => {
    const header = [
      "Question",
      "Type",
      "Evidence Required",
      "Score",
      "Level",
      "Marked",
      "Component Code"
    ];

    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    const data = {
      assessment_id: subId,
      exportStatus: true,
      intake: id,
      viaSearch: search,
      viaType: type.arr,
      viaLevel: level.arr,
      viaEvidance: evidenceRequired.arr
    }

    const getEvidenceText = (row) => {
      const evidences = [];
      if (row?.evidence_photo == 1) evidences.push("Photo");
      if (row?.evidence_video == 1) evidences.push("Video");
      if (row?.evidence_lecturer_observation == 1) evidences.push("Lecturer Observation");
      return evidences.length > 0 ? evidences.join(", ") : "-";
    };

    // Helper function to protect fraction-like values from date conversion
    const protectFractionValue = (value) => {
      if (typeof value === 'string' && (value.includes('/') || value.match(/^\d+\/\d+$/))) {
        return `="${value}"`; // Format as Excel formula to preserve as text
      }
      return value;
    };

    GetMarkingAssessmentQuestions(data).then((res) => {
      let allRows = res?.data;

      let exportData = [];
      groups.forEach(group => {
        // Add group questions
        const filteredQuestions = allRows.filter(group.filter);

        if (filteredQuestions.length > 0) {
          exportData.push({
            Question: `${group.name}`,
            Type: "",
            "Evidence Required": "",
            Score: "",
            Level: "",
            Marked: "",
            "Component Code": ""
          });
        }

        filteredQuestions.forEach((row) => {
          const markedValue = row?.mark_status || '-';
          const scoreValue = row?.correct_score || '-';

          const hasEvidence =
            row?.evidence_photo === 1 ||
            row?.evidence_video === 1 ||
            row?.evidence_lecturer_observation === 1;

          exportData.push({
            Question: row?.question_name || '-',
            Type: row?.question_type
              ? RenderQuestionType(row?.question_type?.trim())?.text
              : '-',
            'Evidence Required': hasEvidence
              ? getEvidenceText(row)
              : '-',
            Score: isNotGraded
              ? 'Not Graded'
              : scoreValue,
            Level: row?.level_name
              ? RenderQuestionLevel(row?.level_name)?.text
              : '-',
            Marked: isNotGraded
              ? 'Not Graded'
              : markedValue,
            'Component Code': row?.component_code || '-',
          });
        });
      });

      if (fileType === "csv") {
        // Process data to protect numeric fractions in both Score and Marked fields
        const processedData = exportData.map(row => {
          const newRow = { ...row };

          // Protect both Score and Marked fields
          if (typeof newRow.Score === 'string' && newRow.Score.includes('/')) {
            newRow.Score = protectFractionValue(newRow.Score);
          }

          if (typeof newRow.Marked === 'string' && newRow.Marked.includes('/')) {
            newRow.Marked = protectFractionValue(newRow.Marked);
          }

          return newRow;
        });

        // Use these options for Windows Excel compatibility
        const csvString = Papa.unparse(processedData, {
          quotes: true,
          quoteChar: '"'
        });

        // Add BOM character for Windows Excel
        const BOM = "\uFEFF";
        const blobContent = BOM + csvString;

        const blob = new Blob([blobContent], { type: "text/csv;charset=utf-8" });
        const blobURL = window.URL.createObjectURL(blob);

        // Create new tag for download file
        const anchor = document.createElement("a");
        anchor.download = fileName;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = [
          "text/csv",
          anchor.download,
          anchor.href,
        ].join(":");
        anchor.click();

        // Remove URL.createObjectURL. The browser should not save the reference to the file.
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          URL.revokeObjectURL(blobURL);
        }, 1000);
        Swal.close();
      } else if (fileType === "xlsx") {
        // For Excel export, we need to format cells containing fractions as text
        const compatibleData = exportData.map((row) => {
          const obj = {};
          header.forEach((col) => {
            obj[col] = row[col];
          });
          return obj;
        });

        let wb = XLSX.utils.book_new();
        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
          header,
        });

        // Format cells in both Score and Marked columns as text
        const scoreColIndex = header.indexOf("Score");
        const markedColIndex = header.indexOf("Marked");

        const formatColumnAsText = (colIndex) => {
          if (colIndex !== -1) {
            const range = XLSX.utils.decode_range(ws1['!ref']);
            for (let rowNum = range.s.r + 1; rowNum <= range.e.r; rowNum++) {
              const cellRef = XLSX.utils.encode_cell({ r: rowNum, c: colIndex });
              if (!ws1[cellRef]) continue;

              // Set the cell type to string
              ws1[cellRef].t = 's';

              // If it's a fraction, ensure it's a string
              if (typeof ws1[cellRef].v === 'string' && ws1[cellRef].v.includes('/')) {
                ws1[cellRef].v = String(ws1[cellRef].v);
              }
            }
          }
        };

        formatColumnAsText(scoreColIndex);
        formatColumnAsText(markedColIndex);

        XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
        Swal.close();
        return false;
      }
      if (fileType === "pdf") {
        const compatibleData = exportData.map((row) => {
          return [
            row["Question"],
            row["Type"],
            row["Evidence Required"],
            row["Score"],
            row["Level"],
            row["Marked"],
            row["Component Code"],
          ];
        });
        const doc = new JsPDF();
        doc.autoTable({
          head: [header],
          body: compatibleData,
          styles: {
            minCellHeight: 10,
            minCellWidth: 5,
            halign: "left",
            fontSize: 8,
          },
        });
        doc.save(`${fileName}.pdf`);
        Swal.close();
        return false;
      }
    }).catch((err) => {
      console.error(err)
    });
  };

  const tableBottomButton = useMemo(() => [
    {
      title: assessmentDetails?.notify_assessed ? "Re-Open Marking" : "Mark as Complete",
      icon: "bell",
      className: "btn-bottom-button",
      onClick: assessmentDetails?.notify_assessed ? (e) => submitNotification(e, "reOpen") : null,
      disabled: assessmentDetails?.markAsComplete == 0 ? false : true
    },
    ...(isHybrid ? [{
      title: "Download Assessments",
      icon: "arrow-down",
      onClick: () => {
       handleDownloadAssessment({assignmentId : subId},setFinalLoadedData,setFinalTotal, "downloadAssessment" , assessmentDetails?.name || ""  )
      },
      disabled: false
    }] : []),
    ...(isHybrid ? [{
      title: "Import Marks",
      icon: "arrow-up",
      disabled: assessmentDetails?.notify_assessed ? true : false
    }] : []),
    {
      title: "Download Smart Assessment Results",
      icon: "arrow-down",
      onClick: () => handleDownloadAssessment({assignmentId : subId, isSmartAssessment : 1},setFinalLoadedData,setFinalTotal, "downloadAssessment" , assessmentDetails?.name || ""  ),
      disabled: false
    }
  ], [isHybrid, assessmentDetails?.notify_assessed, assessmentDetails?.name])

  const submitZipForm = () => {
    const data = new FormData();
    data.append("import", zipfileupload[0].file)
    GetimportMarks(data)
      .then((response) => {
        popupSuccessSimple("successfully");
        setZipFileUpload("");
        $("#inputfileupload").val("");
        $("#exampleModalCenter").modal("hide");
      }).catch((error) => {
        console.error("zipupload error", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text: 'Error',
        });
      })
  }

  const setNotificationvalue = (e) => {
    const check = e.target.checked
    check === true ? setNotificationVal(true) : setNotificationVal(false)
  }

  const submitNotification = (e, type) => {
    setMarkingLoading(true)
    const data = new FormData();
    data.append("assignmentid", subId);
    data.append("intake", id);
    data.append("act", type == "reOpen" ? 0 : 1);
    data.append("notifyToAll", notificationval)
    GetMarkasCompelete(data)
      .then((response) => {
        popupSuccessSimple("successfully");
        setNotificationVal(false)
        setMarkingLoading(false)
        fetchAssessmentDetails()
        $("#exampleModal2").modal("hide");
      }).catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: 'Error',
        });
        setMarkingLoading(false)
      });
  }

  const dropdownOptions = () => {
    GetMarkingAssessmentQuestionsFilters(subId, id)
      .then((res) => {
        setFilterData({
          type: res?.data?.questionTypeFilters,
          evidenceRequired: res?.data?.questionEvidence,
          level: res?.data?.questionLevelFilter
        })
      })
      .catch((err) => {
        console.error(err, "Error fetching dropdown options");
      })
  }

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setDebouncedTerm(value);
  };

  const resetFilter = () => {
    setType({ arr: [], checkObj: {} });
    setEvidenceRequired({ arr: [], checkObj: {} });
    setLevel({ arr: [], checkObj: {} });
    setDebouncedTerm("");
    setSearch("");
  };

  useEffect(() => {
    const applyRowStyles = () => {
      const rows = document.querySelectorAll('.rdt_TableRow');
      rows.forEach((row, index) => {
        if (!groupedQuestions[index]?.isGroupHeader) {
          row.className = `rdt_TableRow ${groupedQuestions[index]?.className || ''}`;
        }
      });
    };

    const timer = setTimeout(applyRowStyles, 100);

    return () => clearTimeout(timer);
  }, [groupedQuestions]);

  useEffect(() => {
    dropdownOptions();
  }, []);

  useEffect(() => {
    const cancelTokenSources = [];

    const fetchQuestions = async () => {
      setQuestionLoading(true);

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);

      try {
        const data = {
          assessment_id: subId,
          exportStatus: true,
          intake: id,
          viaSearch: search,
          viaType: type.arr,
          viaLevel: level.arr,
          viaEvidance: evidenceRequired.arr
        }

        const res = await GetMarkingAssessmentQuestionsCancelToken(data, source.token);
        if (res.status === 200) {
          setQuizQuestions(res?.data);
          setTotalRows(res?.data?.total);
          const filter = ['Evidence Only', 'Document Upload', 'Long Answer'];
          const hasHybrid = res?.data?.some(item => filter.includes(item.question_type));
          setIsHybrid(hasHybrid)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      } finally {
        setQuestionLoading(false);
      }
    };

    fetchQuestions();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [search, type, evidenceRequired, level]);

  useEffect(() => {
    const timer = setTimeout(() => setSearch(debouncedTerm), 1000);
    return () => {
      clearTimeout(timer);
    }
  }, [debouncedTerm])
  return (
    <>
      <div className="my-tickets-info-list Tickets-main-wrap">
        <div className="custom-table-div filter-search-icon card card-table-custom program-table">
          <div className="table-title mb-3" title="Questions">Questions</div>
          <div className="search-filter-div">
            <div className="search-filter-div-left">
              <div className="system-administration-table table-responsive">
                <div className="table-responsive-div">
                  <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                    <div id="assessment-table-main_filter" className="dataTables_filter">
                      <label>
                        <input
                          type="search"
                          className=""
                          placeholder="Search"
                          aria-controls="assessment-table-main"
                          onChange={handleSearchFilter}
                          value={debouncedTerm}
                        />
                      </label>
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filter-button-group">
                  <div className="filter-scroll">
                    <div className={`filter-scroll-inner filter-custom-new`}>
                      <Tablefilter
                        filterName="Type"
                        optionArr={filterData?.type}
                        state={type}
                        setState={setType}
                        renderLabelFunction={RenderQuestionType}
                      />
                    </div>
                  </div>
                  <div className="filter-scroll">
                    <div className={`filter-scroll-inner filter-custom-new`}>
                      <Tablefilter
                        filterName="Evidence Required"
                        optionArr={filterData?.evidenceRequired}
                        state={evidenceRequired}
                        setState={setEvidenceRequired}
                        renderLabelFunction={RenderEvidences}
                      />
                    </div>
                  </div>
                  <div className="filter-scroll">
                    <div className={`filter-scroll-inner filter-custom-new`}>
                      <Tablefilter
                        filterName="Level"
                        optionArr={filterData?.level}
                        state={level}
                        setState={setLevel}
                        renderLabelFunction={RenderQuestionLevel}
                      />
                    </div>
                  </div>
                  <div className="reset-btn-group">
                    <div className="button-reset dropdown-comman">
                      <button
                        className="btn btn-primary"
                        onClick={resetFilter}
                        title="Reset"
                      >
                        <i className="fal fa-redo"></i>Reset
                      </button>
                    </div>
                    <div className="files-export-group">
                      <button
                        type="button"
                        className="btn btn-files"
                        onClick={() => {
                          exportData("xlsx", "Assessment Questions List");
                        }}
                        title="Export spreadsheet"
                      >
                        <i className="fal fa-file-excel icon"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-files"
                        onClick={() => {
                          exportData("csv", "Assessment Questions List");
                        }}
                        title="Export CSV"
                      >
                        <i className="fal fa-file-csv icon"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-files"
                        onClick={() => {
                          exportData("pdf", "Assessment Questions List");
                        }}
                        title="Export PDF"
                      >
                        <i className="fal fa-file-pdf icon"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <DataTable
            progressPending={questionLoading}
            data={groupedQuestions}
            progressComponent={<SkeletonTicketList />}
            columns={columns}
            pagination={false}
            sortServer
            highlightOnHover={false}
          />

          {quizQuestions?.length > 0 && <div className='d-flex align-items-center flex-wrap mt-4'>
            {
              tableBottomButton?.map((button, index) => {
                return (
                    (button?.title == "Download Assessments"  || button?.title == "Download Smart Assessment Results") ? 
                   ( <DownloadModalComponent 
                    children={
                      <button
                    key={index}
                    type="button"
                    className={`btn ${button?.className ? button?.className : 'btn-primary'} ${index == tableBottomButton?.length - 1 ? '' : 'mr-3'} mt-xl-0 mt-3`}
                    title={button.title}
                    data-toggle={(button?.title == "Import Marks" || button?.title == "Mark as Complete" || button?.title == "Download Assessments") ? "modal" : ""}
                    data-target={button?.title == "Import Marks" ? "#exampleModalCenter" : button?.title == "Mark as Complete" ? "#exampleModal2" : button?.title == "Download Assessments" ? "#downloadAssessment" : ""}
                  >
                    {(button?.title == "Download Smart Assessment Results" ? downloading : ((assessmentDetails?.markAsComplete == 0 && button?.title == "Mark as Complete") || button?.title == "Re-Open Marking") && markingLoading) ? <i className="fas fa-cog fa-spin"></i> : <i className={`fal fa-${button?.icon}`}></i>} {button?.title}
                  </button>
                    } downloadRef={downloadRef} payload={{assignmentId : subId ,intake : id, isSmartAssessment : button.title == "Download Smart Assessment Results" ? 1 : 0}} zipName={assessmentDetails?.name || ""} modalId={'downloadAssessment'}
                    />) : 
                   ( <button
                    key={index}
                    type="button"
                    className={`btn ${button?.className ? button?.className : 'btn-primary'} ${index == tableBottomButton?.length - 1 ? '' : 'mr-3'} mt-xl-0 mt-3`}
                    title={button.title}
                    onClick={(button?.title == "Download Assessments" || button?.title == "Download Smart Assessment Results" || button?.title == "Re-Open Marking") ? button.onClick : null}
                    data-toggle={(button?.title == "Import Marks" || button?.title == "Mark as Complete" || button?.title == "Download Assessments") ? "modal" : ""}
                    data-target={button?.title == "Import Marks" ? "#exampleModalCenter" : button?.title == "Mark as Complete" ? "#exampleModal2" : button?.title == "Download Assessments" ? "#downloadAssessment" : ""}
                    disabled={(button?.title == "Download Smart Assessment Results" ? downloading : (button?.title == "Re-Open Marking" || (assessmentDetails?.markAsComplete == 0 && button?.title == "Mark as Complete")) && markingLoading) ? true : button?.disabled}
                    >
                    {(button?.title == "Download Smart Assessment Results" ? downloading : ((assessmentDetails?.markAsComplete == 0 && button?.title == "Mark as Complete") || button?.title == "Re-Open Marking") && markingLoading) ? <i className="fas fa-cog fa-spin"></i> : <i className={`fal fa-${button?.icon}`}></i>} {button?.title}
                    </button>)
                )
              })
            }
          </div>}
        </div>
      </div>

      <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">Import csv for mark capture</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="import_capture_inputs">
                <form onSubmit={submitZipForm}>
                  <div className="drag_card_btn">
                    <FilePond
                      name="CSVFILE"
                      allowMultiple={false}
                      ref={inputRef}
                      files={zipfileupload}
                      onupdatefiles={setZipFileUpload}
                      acceptedFileTypes='application/csv,text/csv,.csv'
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button type="submit" disabled={!zipfileupload} className="btn btn-primary" onClick={submitZipForm}>Import</button>
              <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={() => setZipFileUpload("")}>Cancel</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="exampleModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Notification !</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" disabled={notificationval}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <input type="checkbox" id="checkboxid" name="notificationval" checked={notificationval} onChange={(e) => setNotificationvalue(e)} />
              &nbsp;&nbsp;
              <label htmlFor="checkboxid">Notify All Students</label>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" onClick={submitNotification}><i className="fal fa-check"></i>Send</button>
              <button type="button" className="btn btn-danger" data-dismiss="modal"><i className="fal fa-times"></i>Close</button>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default AssessmentStudentList
